<mat-card class="individual-user-card">
  <mat-card-header class="header">
    <mat-card-title class="card-title">
      Individual Maintenance
    </mat-card-title>
    <mat-card-subtitle class="card-subtitle">
      Enter name and organization (optional) and click search to add a new Individual or update an existing Individual
    </mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>

  <div class="tp-form">
    <!-- Search Form Fields -->
    <div class="search-row">
      <mat-form-field class="search-field" appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput placeholder="Search by Name" [(ngModel)]="indName">
      </mat-form-field>

      <mat-form-field class="search-field" appearance="outline">
        <mat-label>Organization</mat-label>
        <mat-select [(ngModel)]="individualService.selectedOrg" [compareWith]="compareOrganizations" class="org-select" (openedChange)="onOrgDropdownOpen()" panelClass="org-panel">
          <mat-option disabled class="org-search-option" (click)="$event.stopPropagation()">
            <input class="org-search-input" 
                   type="text" 
                   placeholder="Search organization..." 
                   [(ngModel)]="orgSearchText" 
                   (input)="filterOrganizations(); $event.stopPropagation()"
                   (click)="$event.stopPropagation()"
                   (keydown)="$event.stopPropagation()"
                   (keyup)="$event.stopPropagation()"
                   (blur)="$event.stopPropagation()">
          </mat-option>
          <mat-divider class="org-search-divider"></mat-divider>
          <mat-option *ngFor="let org of filteredOrgList" [value]="org" class="org-option">
            {{org.DESCRIPTION}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Action Buttons -->
    <div class="tp-button">
      <button class="action-button" mat-raised-button color="primary" (click)="doSearch()">Search</button>
      <button class="action-button" mat-raised-button color="primary" [disabled]="isNewDisabled()" (click)="newIndividual()">New</button>
      <button class="action-button" mat-raised-button color="primary" (click)="refresh()">Reset</button>
    </div>

    <!-- Filter Section -->
    <div *ngIf="!loading">
      <mat-form-field class="tp-full-width">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter Text" [(ngModel)]="filterText">
      </mat-form-field>
    </div>

    <!-- Loading Spinner -->
    <div class="results-loader" *ngIf="loading">
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>

    <!-- No Results Message -->
    <h3 class="no-results" *ngIf="!loading && individualService.indvList.length < 1">
      No Search Results
    </h3>

    <!-- Results Table -->
    <div class="table-scroll-container" *ngIf="individualService.indvList.length > 0">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 tp-full-width">
        <!-- Full Name Column -->
        <ng-container matColumnDef="FULLNAME">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Individual Name</th>
          <td mat-cell *matCellDef="let element">{{element.FULLNAME}}</td>
        </ng-container>

        <!-- Table Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="curr-cust" (click)="handleClick(row)"></tr>
      </table>
    </div>
  </div>
</mat-card>
